import { render, staticRenderFns } from "./nodeWrap.vue?vue&type=template&id=083e2f2f&scoped=true"
import script from "./nodeWrap.vue?vue&type=script&lang=js"
export * from "./nodeWrap.vue?vue&type=script&lang=js"
import style0 from "./nodeWrap.vue?vue&type=style&index=0&id=083e2f2f&prod&scoped=true&lang=css"
import style1 from "./nodeWrap.vue?vue&type=style&index=1&id=083e2f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e2f2f",
  null
  
)

/* custom blocks */
import block0 from "./nodeWrap.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports